export default {
      id: "weather__thunder-rainy-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__thunder-rainy",
      toString: function () {
        return this.url;
      }
    }